import noImage from "assets/images/no image.png";
import { ComponentProps, useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";

const placeholder =
  "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";

export default function Image({
  src,
  alt,
  className,
  ...props
}: ComponentProps<"img">) {
  const hasSrc = !!src;
  const [currentSrc, setCurrentSrc] = useState(hasSrc ? placeholder : noImage);
  const [isLoading, setIsLoading] = useState(hasSrc);

  useEffect(() => {
    if (!hasSrc) {
      setCurrentSrc(noImage);
      setIsLoading(false);
      return;
    }

    let isActive = true;

    setCurrentSrc(placeholder);
    setIsLoading(true);

    const image = new window.Image();
    image.src = src;
    image.onload = () => {
      if (!isActive) return;
      setCurrentSrc(src);
      setIsLoading(false);
    };
    image.onerror = () => {
      if (!isActive) return;
      setCurrentSrc(noImage);
      setIsLoading(false);
    };

    return () => {
      isActive = false;
    };
  }, [hasSrc, src]);

  return (
    <img
      src={currentSrc}
      alt={alt}
      aria-busy={isLoading || undefined}
      className={twMerge(
        isLoading && "image-placeholder",
        !src && "bg-default-theme",
        className,
      )}
      {...props}
    />
  );
}
